(() => {
  const closeLabel = document.currentScript?.dataset.closeLabel;
  const reviewLabel = document.currentScript?.dataset.reviewLabel;
  if (!closeLabel || !document.body || document.documentElement.hasAttribute('data-leslis-review-popup-accessibility')) return;
  document.documentElement.setAttribute('data-leslis-review-popup-accessibility', 'true');

  const selector = '.jdgm-popup-card span.jdgm-popup-card__close-btn[role="button"]:not([tabindex])';
  const upgradedSelector = '.jdgm-popup-card span.jdgm-popup-card__close-btn[data-leslis-popup-close="true"]';
  const reviewSelector = '.jdgm-popup-card a.jdgm-popup-card__full-rev-link';
  const armed = new WeakSet();

  const upgrade = (root) => {
    if (!(root instanceof Element)) return;
    const controls = root.matches(selector) ? [root] : [];
    controls.push(...root.querySelectorAll(selector));
    controls.forEach((control) => {
      control.tabIndex = 0;
      control.setAttribute('aria-label', closeLabel);
      control.setAttribute('data-leslis-popup-close', 'true');
    });
    if (reviewLabel) {
      const links = root.matches(reviewSelector) ? [root] : [];
      links.push(...root.querySelectorAll(reviewSelector));
      links.forEach((link) => {
        if (!link.textContent.trim() && !link.getAttribute('aria-label')?.trim() &&
            !link.hasAttribute('aria-labelledby') && !link.getAttribute('title')?.trim()) {
          link.setAttribute('aria-label', reviewLabel);
        }
      });
    }
  };

  const closeControl = (event) => event.target instanceof Element ? event.target.closest(upgradedSelector) : null;
  const modified = (event) => event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.isComposing;

  document.addEventListener('keydown', (event) => {
    const control = closeControl(event);
    if (!control || event.defaultPrevented || modified(event)) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      armed.delete(control);
      if (!event.repeat) control.click();
    } else if (event.key === ' ') {
      event.preventDefault();
      if (!event.repeat) armed.add(control);
    }
  });

  document.addEventListener('keyup', (event) => {
    const control = closeControl(event);
    if (!control || event.key !== ' ' || !armed.has(control)) return;
    armed.delete(control);
    if (event.defaultPrevented || modified(event) || !control.isConnected) return;
    event.preventDefault();
    control.click();
  });

  document.addEventListener('focusout', (event) => {
    const control = closeControl(event);
    if (control) armed.delete(control);
  });

  upgrade(document.body);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(upgrade));
  }).observe(document.body, { childList: true, subtree: true });
})();
